<template lang="pug">
	.airbraker-filtered-ips(v-if="showed")
		.modal(:tabindex="-1" :role="'dialog'" :style="{'display': 'block'}")
			.modal-dialog.modal-dialog-centered(:role ="'document'")
				.modal-content
					.modal-header
						h5.modal-title Airbraker Filtered IPs
					.modal-body
						.modal-loading(v-if="!received")
							.icon.fa.fa-spinner.fa-spin
						.modal-loaded(v-else)
							.form-group
								textarea.form-control(:rows="7" v-model="newIPs" )
					.modal-footer
						button.btn.btn-primary(type="button" v-on:click="save") Save
						button.btn.btn-dark(type="button" v-on:click="close") Close

</template>
<script>
	import Screen 				from './../../mixins/screen';

	export default {
		name: 'SettingsEditAirbrakerFilteredIps',
		mixins: [Screen],
		screen: {
			events: {
				"Airbraker Filtered IPs Received": function (ips) {

					this.received = true;
					this.newIPs = ips.join('\n');

				}
			},
			updateOn: [],
			showed: false,
			received: false
		},
		data() {
			return {
				newIPs: '',
				received: false
			}
		},
		methods: {
			collectData() {
				this.received = false;
			},
			close() {
				this.hide();
			},
			save() {

				Server.sendToSocket({
					AirbrakerUpdatedFitlteredIPs: {
						IPs: this.newIPs.split('\n')
					}
				});
				this.close();
			}
		}

	}
</script>
<style lang="sass">

	.airbraker-filtered-ips
		position: absolute
		z-index: 2000
		left: 0
		top: 0
		right: 0
		bottom: 0
		background-color: rgba(0, 0, 0, 0.6)

		.modal-content
			border: none
			background: none

			.modal-header
				background-color: #343b41
				border-bottom: 1px solid #23282c
				color: #e4e7ea

			.modal-body
				background-color: #3a4149

				.modal-loading
					display: flex
					width: 100%
					align-items: center
					flex-direction: column
					justify-content: center

					.fa-spin
						font-size: 50px
						color: #e4e7ea

				.modal-loaded

					textarea
						background-color: #515b65
						color: #c8ced3
						border-color: #c8ced3

			.modal-footer
				background-color: #3a4149
				border: none
				justify-content: space-between


</style>
